export const SUGGESTED_KEYWORDS_STORE_KEY = '__SUGGESTED_KEYWORDS__';
export const INITIAL_STATE = {
    keywords: [],
    customKeywords: [],
};
